import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function repacking() {
    return {
        index,
        get,
        update,
        addItem,
        removeItem,
        print,
        reject,
        save,
        processShipping,
        processWhrecToGuide,
        processShippingInEntity
    };

    function index(options = {}) {
        const defaultValues = {};
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`reempack/search${params}`);
    }

    function save(payload) {
        if (payload.id) {
            return axiosInstance.post('reempack/update', payload);
        } else {
            return axiosInstance.post('reempack/create', payload);
        }
    }

    function get(id) {
        return axiosInstance.get(`reempack/get?id=${id}`);
    }

    function update(payload) {
        return axiosInstance.post('reempack/update', payload);
    }

    function addItem(reempackId, items) {
        return axiosInstance.post('reempack/add-items', { reempackId, items });
    }

    function removeItem(payload) {
        return axiosInstance.delete('reempack/remove-items', {
            data: payload
        });
    }

    function print(id) {
        return axiosInstance.get(`reempack/print?id=${id}`, {
            responseType: 'arraybuffer',
            headers: {
                Accept: 'application/pdf',
                'Content-Type': 'application/json'
            }
        });
    }

    function reject(payload) {
        return axiosInstance.post(`reempack/reject`, payload);
    }

    function processShipping(payload) {
        return axiosInstance.post('reempack/process-shipping', payload);
    }

    function processWhrecToGuide(id) {
        return axiosInstance.post('reempack/process-whrec-to-guide', { id });
    }

    function processShippingInEntity(payload) {
        return axiosInstance.post(
            'reempack/process-shipping-in-entity',
            payload
        );
    }
}
